import { autoinject, PLATFORM, useView } from 'aurelia-framework';

import { BaseDialog, BaseDialogModel } from '~/components/dialog/base-dialog';

export interface FormInfoDialogModel extends BaseDialogModel {
	formName: string;
	customisationName: string;
	customisationFile: string;
	classicFormName: string;
}

@autoinject
@useView(PLATFORM.moduleName('./form-info-dialog.html'))
export class FormInfoDialog extends BaseDialog<FormInfoDialogModel> {}
